document.addEventListener('DOMContentLoaded', function() {
    if (window.innerWidth <= 768) { // Nur für mobile Geräte
      const richText = document.querySelector('.template-index .section-richtext .rich-text__text');
      if (!richText) return;
      const paragraphs = richText.querySelectorAll('p');
      if (paragraphs.length > 1) {
        let hiddenContent = '';
        for (let i = 1; i < paragraphs.length; i++) {
          hiddenContent += paragraphs[i].outerHTML;
          paragraphs[i].style.display = 'none';
        }
        
        const showMoreButton = document.createElement('span');
        showMoreButton.textContent = 'mehr anzeigen';
        showMoreButton.style.color = '#e2001a';
        showMoreButton.style.cursor = 'pointer';
        richText.appendChild(showMoreButton);

        showMoreButton.addEventListener('click', function() {
          const isHidden = paragraphs[1].style.display === 'none';
          for (let i = 1; i < paragraphs.length; i++) {
            paragraphs[i].style.display = isHidden ? 'block' : 'none';
          }
          showMoreButton.textContent = isHidden ? 'weniger anzeigen' : 'mehr anzeigen';
        });
      }
    }
  });